import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CollectionService } from '@services/collection.service';
import { NotificationService } from '@services/notification.service';
import { WebErrorService } from '@services/webError.service';
import { Subscription } from 'rxjs';
import { customValidationService } from 'src/app/shared/custom.validator';

@Component({
  selector: 'app-create-new-style',
  templateUrl: './create-new-style.component.html',
  styleUrls: ['./create-new-style.component.scss']
})
export class CreateNewStyleComponent implements OnInit {
  isNewStyle: boolean = true;
  basicDetailsForm: FormGroup;
  @Input() isPublished: any;
  newStyleSubscription: Subscription;
  updateStyleSubscription: Subscription;
  globalcollectionuuId: any;

  constructor(public dialogRef: MatDialogRef<CreateNewStyleComponent>,
    private CollectionService: CollectionService,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    @Inject(MAT_DIALOG_DATA) public Data: any) {
      this.isNewStyle = this.Data.type;
      this.globalcollectionuuId = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    }

  ngOnInit(): void {
    this.createForm();

    if (this.Data != null) {
      if (this.Data.row.styleId) {
        this.CollectionService.getStyleDetails(this.Data.styleGroupId, this.Data.row.styleId).subscribe(res => {
          this.basicDetailsForm.setValue({
            styleId: res.data.styleId,
            styleName: res.data.styleName,
            description: res.data.description
          });
        });
      }
    }
  }

  createForm(): void {
    this.basicDetailsForm = new FormGroup({
      styleId: new FormControl(0),
      styleName: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(120),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/)
      ]
      ),
      description: new FormControl('',
        [
          Validators.minLength(1),
          Validators.maxLength(480),
        ]
      )
    });
  }

  get f() {
    return this.basicDetailsForm.controls;
  }

  saveStyle() {
    if (this.basicDetailsForm.valid) {
      if (this.isNewStyle) {
        this.CollectionService.createNewStyle(this.Data.styleGroupId, this.basicDetailsForm.value).subscribe(style => {
          if (style.success) {
            this.notificationService.success(style.message);
            this.closeDialog();
          }
        }, (error: any) => { this.webErrorService.handleAPIErrors(error, '', true, 'warn'); });
      } else {
        this.CollectionService.updateStyle(this.Data.styleGroupId, this.basicDetailsForm.value).subscribe(style => {
          if (style.success) {
            this.notificationService.success(style.message);
            this.closeDialog();
          }
        }, (error: any) => { this.webErrorService.handleAPIErrors(error, '', true, 'warn'); });
      }
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
